import React from 'react'

import Claim from './Claim'
import Parts from './Parts'
import Preview from './Preview'

export default function Strongest({ argument, theme, id }) {
  return (
    <div className={theme.strongest}>
      <header className={theme.header}>Select your strongest argument</header>

      <section className={theme.container}>
        <Claim imgUrl={argument.imgUrl} text={argument.text} />

        <section className={theme.table}>
          <Parts parts={argument.parts} />

          <Preview id={id} />
        </section>
      </section>
    </div>
  )
}



// WEBPACK FOOTER //
// ./client/modules/debate/components/Strongest/Strongest.js